module.exports = __webpack_public_path__ + "img/volcano.469515ca.svg";